export enum HelpPanelState {
    Topics = 'Topics',
    Search = 'Search',
    Articles = 'Articles',
    Article = 'Article'
}
